import { PatientPayersActions } from 'src/redux/actions/constant';

const {
  GET_PAYER_OPTIONS_SUCCESS,
  GET_PAYER_OPTIONS_FAILURE,
  GET_PAYER_OPTIONS_LOADING,
  GET_PAYER_OPTIONS_RESET,
} = PatientPayersActions;

const initialState: any = {
  response: null,
  loading: false,
};

export const getPayerOptionsReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case GET_PAYER_OPTIONS_SUCCESS:
      return {
        ...state,
        response: action.payload,
        loading: false,
      };

    case GET_PAYER_OPTIONS_FAILURE:
      return {
        ...state,
        response: null,
        loading: false,
      };

    case GET_PAYER_OPTIONS_LOADING:
      return {
        ...state,
        loading: true,
      };

    case GET_PAYER_OPTIONS_RESET:
      return initialState;

    default:
      return state;
  }
};
